export default "__VITE_ASSET__BHEPYXjW__"